export default __webpack_public_path__ + "static/media/Q03_橙花糖霜的水果冰淇淋.46558613.mp4";